/**
 * Runtime API URL configuration
 * This determines the backend URL at RUNTIME, not build time
 * Ensures alvins.place always uses same-origin requests
 */

export const getApiUrl = () => {
  // ALWAYS use same-origin (empty string) for alvins.place
  if (typeof window !== 'undefined') {
    const hostname = window.location.hostname;
    if (hostname === 'alvins.place' || hostname === 'www.alvins.place') {
      return '';
    }
  }
  
  // For other environments, use the env var if set
  return process.env.REACT_APP_BACKEND_URL || '';
};

// Export a constant for backward compatibility, but it's evaluated at runtime
export const API_URL = typeof window !== 'undefined' ? getApiUrl() : '';

export default getApiUrl;
